export default __webpack_public_path__ + "static/media/loader.a1fe261c.gif";